import React, { useState } from "react";
import { useQuery } from "react-query";
import axios from "../axios";
import LoadingBar from "react-top-loading-bar";
import { Link } from "react-router-dom";
import HomeSkelton from "../Skeltons/HomeSkelton";

const HomePage = () => {
  const [progress, setProgress] = useState(0);

  const { data, isLoading } = useQuery("products", async () => {
    setProgress(30); // بدء الـLoadingBar
    const response = await axios.get("/products");
    setProgress(100); // إنهاء الـLoadingBar
    return response.data;
  });

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">أحدث المنتجات</h1>
      <LoadingBar
        color="#f11946"
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      {isLoading ? (
        // عرض Skeleton عندما تكون البيانات في حالة تحميل
        <div className="grid grid-cols-4 gap-4">
          {Array.from({ length: 8 }).map((_, index) => (
            <HomeSkelton key={index} />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-4 md:grid-cols-2  gap-4">
          {data.map((product) => (
            <div
              key={product.id}
              className="shadow rounded-lg flex flex-col p-2"
            >
              <img
                src={`https://api.van-graph.com/storage/${product.main_image}`}
                alt={product.name}
                loading="lazy"
                className="h-72 object-cover mb-3"
              />
              <h2 className="text-lg font-bold mb-4">{product.name}</h2>

              {/* إضافة max-h مع line-clamp لتحديد الطول الأقصى للوصف */}
              <p className="flex-grow line-clamp-5 mb-4">
                {product.description}
              </p>

              {/* تثبيت زر الشراء في الأسفل */}
              <Link
                to={`product/${product.id}`}
                className="px-4 py-2 border rounded text-center mt-auto border-gray-800 bg-gray-800 text-white hover:bg-transparent hover:text-gray-800 transition"
              >
                شراء
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HomePage;
